import React from 'react';
import './Header.css';

interface HeaderProps {
    onSettingsClick: () => void;
}

export function Header({ onSettingsClick }: HeaderProps) {
    return (
        <div className="header">
            <div className="header-content">
                <div>
                    <h1>🐾 Foster Pal</h1>
                    <p>Rescue. Track. Repeat.</p>
                </div>
                <button className="settings-btn" onClick={onSettingsClick}>
                    ⚙️
                </button>
            </div>
        </div>
    );
}